/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/kql.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Performs a KQL query. Returns true if the provided KQL query string matches the row.
 *
 * @example
 * FROM books
 * | WHERE KQL("author: Faulkner")
 *
 * @example
 * FROM employees
 * | WHERE KQL("mary", {"case_insensitive": true, "default_field": "first_name", "boost": 1.5})
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'kql',
  signatures: [
    {
      params: [
        {
          name: 'query',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'case_insensitive\', values=[true, false], description=\'If true, performs case-insensitive matching for keyword fields. Defaults to false.\', type=[boolean]}, {name=\'time_zone\', values=[UTC, Europe/Paris, America/New_York], description=\'UTC offset or IANA time zone used to interpret date literals in the query string.\', type=[keyword]}, {name=\'default_field\', values=[*, logs.*, title], description=\'Default field to search if no field is provided in the query string. Supports wildcards (*).\', type=[keyword]}, {name=\'boost\', values=[2.5], description=\'Floating point number used to decrease or increase the relevance scores of the query. Defaults to 1.0.\', type=[float]}',
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'query',
          type: 'text',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'case_insensitive\', values=[true, false], description=\'If true, performs case-insensitive matching for keyword fields. Defaults to false.\', type=[boolean]}, {name=\'time_zone\', values=[UTC, Europe/Paris, America/New_York], description=\'UTC offset or IANA time zone used to interpret date literals in the query string.\', type=[keyword]}, {name=\'default_field\', values=[*, logs.*, title], description=\'Default field to search if no field is provided in the query string. Supports wildcards (*).\', type=[keyword]}, {name=\'boost\', values=[2.5], description=\'Floating point number used to decrease or increase the relevance scores of the query. Defaults to 1.0.\', type=[float]}',
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
